import React from 'react';

/**
 * Extracts YouTube video IDs from HTML string.
 * Handles:
 *   https://www.youtube.com/watch?v=ID
 *   https://youtu.be/ID
 *   https://youtube.com/watch?v=ID
 *   https://m.youtube.com/watch?v=ID
 *   https://www.youtube.com/embed/ID  (already embedded links)
 */
export function extractYouTubeIds(html) {
  if (!html) return [];
  const pattern = /(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/g;
  const ids = [];
  let match;
  while ((match = pattern.exec(html)) !== null) {
    if (!ids.includes(match[1])) {
      ids.push(match[1]);
    }
  }
  return ids;
}

/**
 * Renders embedded YouTube players for all YouTube links found in `html`.
 * Place this below the dangerouslySetInnerHTML content block.
 */
export default function YouTubeEmbed({ html }) {
  const ids = extractYouTubeIds(html);
  if (ids.length === 0) return null;

  return (
    <div className="mt-3 space-y-3">
      {ids.map((id) => (
        <div
          key={id}
          className="relative w-full rounded-lg overflow-hidden border border-slate-200 shadow-sm"
          style={{ paddingBottom: '56.25%' /* 16:9 */ }}
        >
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${id}`}
            title="YouTube видео"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ))}
    </div>
  );
}
